module.exports = __webpack_public_path__ + "img/ics_o_reload.3fbbf686.svg";